const filterBar = () => {
  $('.c-filters__label').click(function () {
    $(this).next('.c-filters__filters').slideToggle()
  })
}

export default filterBar
